var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('actions-dropdown',{ref:"actionsDropdown",attrs:{"actions":_vm.documentActions,"type":_vm.type,"size":_vm.size,"text":_vm.text,"icon":"ellipsis-h"},on:{"action":function($event){return _vm.onDocumentAction($event, _vm.document)}}})}
var staticRenderFns = []

export { render, staticRenderFns }